import { useEffect } from "react";
import { useUserConfigStore } from "../Store/userConfigStore";

const getConfigKey = (item) => {
  if (!item) return "";
  if (item.fixUserConfigMappingId != null) {
    return `id-${item.fixUserConfigMappingId}`;
  }
  return `${item.venueId ?? ""}-${item.userId ?? ""}`;
};

export const useUserConfigWebSocketUpdate = () => {
  const setUserData = useUserConfigStore((state) => state.setUserData);
  const setTotalElements = useUserConfigStore((state) => state.setTotalElements);

  useEffect(() => {
    const handleUpdate = (event) => {
      const payload = event?.detail;
      if (!payload) return;

      const updatedKey = getConfigKey(payload);
      if (!updatedKey) return;

      const { userData = [], totalElements = 0 } = useUserConfigStore.getState();

      const existingIndex = userData.findIndex((item) => getConfigKey(item) === updatedKey);
      const isDelete = payload.isActive === 0 || payload.isActive === "0";

      if (isDelete) {
        if (existingIndex !== -1) {
          const nextData = userData.filter((item) => getConfigKey(item) !== updatedKey);
          setUserData(nextData);
          setTotalElements(Math.max((totalElements || 0) - 1, 0));
        }
        return;
      }

      if (existingIndex !== -1) {
        const nextData = [...userData];
        nextData[existingIndex] = { ...nextData[existingIndex], ...payload };
        setUserData(nextData);
      } else {
        setUserData([payload, ...userData]);
        setTotalElements((totalElements || 0) + 1);
      }
    };

    window.addEventListener("fixUserConfigUpdate", handleUpdate);
    return () => {
      window.removeEventListener("fixUserConfigUpdate", handleUpdate);
    };
  }, [setUserData, setTotalElements]);
};

export default useUserConfigWebSocketUpdate;
